<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/3 xl:w-1/4 sm:w-full mb-2">
        <div class="vx-card p-5" :style="isSmallerScreen ? '' : `height: 75vh`">
          <vs-input
            class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
            v-model="keyword"
            @keyup="search"
            placeholder="Search..."
          />
          <div class="table-container">
            <h3 class="sidebar-title">Vehicle List</h3>
            <table class="sidebar-table">
              <thead>
                <tr>
                  <th style="min-width: 15px">&nbsp;</th>
                  <th>Device Name (Plate)</th>
                </tr>
              </thead>
              <tbody v-if="data.length > 0">
                <tr v-for="(item, index) in data" :key="index">
                  <td>
                    <vs-row>
                      <vs-col
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                        w="12"
                      >
                        <vs-checkbox
                          icon-pack="feather"
                          icon="icon-video"
                          color="rgb(38, 187, 174)"
                          v-model="selected"
                          :vs-value="item.imei"
                          @click="check(item, $event)"
                        ></vs-checkbox>
                      </vs-col>
                    </vs-row>
                  </td>
                  <td class="text-left p-2">
                    {{ item.device_name }} ({{ item.plate_number }})
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td
                    v-if="loading"
                    colspan="4"
                    class="text-center"
                    style="padding: 10px; border-right: none"
                  >
                    <vs-icon icon-pack="feather" icon="icon-loader"></vs-icon>
                    Loading....
                  </td>
                  <td
                    v-else
                    colspan="4"
                    class="text-center"
                    style="padding: 10px; border-right: none"
                  >
                    No Data Available
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <vs-pagination
            style="margin-top: 20px"
            color="rgb(38, 187, 174)"
            :total="n_page"
            v-model="page"
          ></vs-pagination>
        </div>
      </div>
      <div
        class="vx-col w-full lg:w-2/3 xl:w-3/4 sm:w-full position-relative"
        :style="isSmallerScreen ? `height: 82vh` : `height: 75vh`"
        style=""
      >
        <vs-row>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            class="dashcam-live-streaming"
          >
            <vs-card class="w-full p-1">
              <vs-row
                vs-type="flex"
                vs-justify="space-between"
                style="margin-bottom: 0 !important"
              >
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="center"
                  vs-w="10"
                  vs-xs="12"
                  style="font-size: 14px"
                >
                  <vs-row>
                    <b-form-group
                      label="Pilih Device"
                      v-slot="{ ariaDescribedby }"
                      class="font-weight-bold"
                    >
                      <b-form-radio-group
                        id="radio-group-2"
                        v-model="selectCam"
                        :aria-describedby="ariaDescribedby"
                        name="radio-sub-component"
                        class="font-weight-normal"
                      >
                        <b-form-radio
                          value="0"
                          :style="
                            selectCam == 0
                              ? 'color:#1DA1F2; font-weight:600;'
                              : ''
                          "
                          >Cam 1</b-form-radio
                        >
                        <b-form-radio
                          :disabled="is_disable_cam2"
                          value="1"
                          :style="
                            selectCam == 1
                              ? 'color:#1DA1F2; font-weight:600;'
                              : ''
                          "
                          >Cam 2</b-form-radio
                        >
                      </b-form-radio-group>
                    </b-form-group>
                  </vs-row>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="center"
                  vs-w="2"
                  vs-xs="12"
                  style="font-size: 14px"
                >
                  <vs-row>
                    <vs-col
                      vs-type="flex"
                      vs-justify="flex-start"
                      vs-align="center"
                      vs-w="12"
                    >
                      <span class="font-weight-bold ml-lg-5">Map</span>
                    </vs-col>
                    <div
                      class="ml-lg-5"
                      style="
                        width: 100%;
                        padding: 10px;
                        height: auto;
                        background: #fff;
                        border-radius: 8px;
                        box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
                        transition: all 0.3s ease;
                      "
                    >
                      <vs-col
                        vs-w="5"
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                      >
                        <span for="">On</span>
                      </vs-col>
                      <vs-col vs-w="7">
                        <vs-switch
                          color="#479dd7"
                          v-model="showMap"
                          class="w-full"
                        />
                      </vs-col>
                    </div>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-card>
          </vs-col>
        </vs-row>

        <vs-row
          class="dashcam-live-streaming"
          :style="isSmallerScreen ? 'height:75rem' : 'height:85%'"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            :vs-w="showMap ? 8 : 12"
            vs-sm="12"
            class="my-2 my-sm-0"
            style="transition: all 0.5s ease"
          >
            <vs-card class="w-full h-full p-1 mr-sm-1">
              <div
                v-if="camera.video"
                class="h-full"
                style="background: #000000; border-radius: 10px"
              >
                <fullscreen
                  :fullscreen.sync="fullscreen"
                  class="w-full h-full position-relative"
                >
                  <div
                    id="imgVideo"
                    class="center-div"
                    style="height: 100%"
                  ></div>
                  <vue-flv-player
                    :autoplay="camera.autoplay"
                    :controls="false"
                    :type="camera.type"
                    ref="myPlayer"
                    :muted="camera.sound"
                    :preload="false"
                    :source="camera.src"
                    :config="camera.media"
                    @error="handleError"
                    class="w-full h-full"
                    style="border-radius: 10px"
                  />
                  <vs-row
                    class="center-div"
                    style="
                      top: 88.5%;
                      width: 100%;
                      padding-left: 1.5rem;
                      padding-right: 1.2rem;
                    "
                  >
                    <vs-col vs-w="12">
                      <vs-slider :max="0" />
                    </vs-col>
                  </vs-row>
                  <vs-row class="center-div mt-1" style="top: 94%; width: 96%">
                    <vs-col vs-type="flex" vs-justify="left" vs-w="2">
                      <vs-button
                        color="primary"
                        type="filled"
                        icon-pack="feather"
                        size="small"
                        :icon="
                          camera.control == 'play' ? 'icon-pause' : 'icon-play'
                        "
                        @click="control()"
                        style="
                          height: 20px !important;
                          width: 20px !important;
                          border-radius: 3px !important;
                        "
                        class="mx-1"
                      >
                      </vs-button>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="right" vs-w="10">
                      <vs-button
                        color="white"
                        text-color="#4B465C"
                        type="filled"
                        style="
                          font-size: 0.8em;
                          height: 20px;
                          padding-left: 10px;
                          padding-right: 10px;
                          padding-top: 4px;
                          border-radius: 3px !important;
                          cursor: default;
                        "
                        class="mx-1"
                      >
                        <span
                          class="mr-1"
                          style="
                            width: 7px;
                            height: 7px;
                            background: #ea5455;
                            border-radius: 50%;
                            display: inline-block;
                          "
                        ></span>
                        <span class="font-weight-bold pb-2">Limit Stream </span>
                        <span> {{ camera.limit }}</span>
                      </vs-button>
                      <vs-button
                        color="primary"
                        type="filled"
                        icon-pack="feather"
                        size="small"
                        :icon="camera.sound ? 'icon-volume-x' : 'icon-volume-1'"
                        style="
                          height: 20px !important;
                          width: 20px !important;
                          border-radius: 3px !important;
                        "
                        class="mx-1"
                        @click="handleSound()"
                      >
                      </vs-button>
                      <vs-button
                        color="primary"
                        type="filled"
                        size="small"
                        icon-pack="feather"
                        icon="icon-maximize"
                        style="
                          height: 20px !important;
                          width: 20px !important;
                          border-radius: 3px !important;
                        "
                        class="mx-1"
                        @click="toggle()"
                      >
                      </vs-button>
                    </vs-col>
                  </vs-row>
                </fullscreen>
              </div>
              <div
                v-else
                class="h-full"
                style="background: #f8f7fa; border-radius: 10px"
              >
                <vs-row class="w-full h-full">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="4"
                    vs-sm="12"
                    class="p-md-5 p-0"
                  >
                    <img
                      class="w-full h-full px-2"
                      src="@/assets/images/freepik/no_video.svg"
                      alt="No Video"
                    />
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="center"
                    vs-w="8"
                    vs-sm="12"
                    class="px-1"
                  >
                    <vs-row>
                      <vs-col vs-w="12">
                        <span style="font-weight: 600"
                          >Vehicle Live Stream</span
                        >
                      </vs-col>
                      <vs-col vs-w="12" class="mb-2">
                        <span class="font-weight-bold text-lg"
                          >Pantau aktifitas sekitar kendaraan, Sekaligus
                          tracking secara langsung.</span
                        >
                      </vs-col>
                      <vs-col vs-w="12">
                        <p class="text-secondary">
                          Untuk mulai melihat live streaming dashcam, pilih unit
                          terlebih dahulu ya.
                        </p>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
              </div>
            </vs-card>
          </vs-col>

          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="4"
            vs-sm="12"
            class="my-2 my-sm-0"
            v-show="mapHandle"
          >
            <vs-card class="w-full h-full p-1 ml-sm-1">
              <l-map
                ref="peta"
                :center.sync="map.center"
                :zoom="map.zoom"
                :options="mapOptions"
                style="min-height: 200px; border-radius: 8px"
              >
                <l-tile-layer
                  v-for="tileProvider in tileProviders"
                  :key="tileProvider.name"
                  :name="tileProvider.name"
                  :visible="tileProvider.visible"
                  :url="tileProvider.url"
                  :attribution="tileProvider.attribution"
                  layer-type="base"
                  :options="{ maxZoom: 22 }"
                />
                <l-control-layers position="topright"></l-control-layers>
                <l-rotated-marker
                  :key="1"
                  :lat-lng="vehicle.position"
                  :icon="vehicle.icons"
                  :rotationAngle="vehicle.angle"
                  :visible="vehicle.visible"
                >
                  <l-tooltip
                    :options="{
                      permanent: true,
                      interactive: true,
                      direction: 'right'
                    }"
                    >{{ vehicle.device_name }}</l-tooltip
                  >
                </l-rotated-marker>
                <l-control position="bottomleft">
                  <vs-row
                    vs-justify="center"
                    style="margin-left: -5px; margin-bottom: -10px"
                    v-if="vehicle.visible"
                  >
                    <vs-col
                      type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="11"
                    >
                      <vs-card>
                        <!-- <div slot="header">
                          <h6>Address</h6>
                        </div> -->
                        <div>
                          <span style="font-size: 13px; font-weight: 500">
                            <span style="font-weight: 600">Addresss</span>:
                            {{ vehicle.address }}</span
                          >
                        </div>
                      </vs-card>
                    </vs-col>
                  </vs-row>
                </l-control>
              </l-map>
            </vs-card>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<style>
.dashcam-live-streaming .center-div {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}

.dashcam-live-streaming .bg-video {
  background: #000000;
  border-radius: 8px;
}

.dashcam-live-streaming .vs-card--content {
  margin-bottom: 0;
  height: 100% !important;
}

.dashcam-live-streaming .vs-slider-primary .vs-circles-slider {
  border: 3px solid rgba(var(--vs-primary), 1);
}

.dashcam-live-streaming .vs-slider--circle {
  width: 15px;
  height: 15px;
  top: -5px;
}

.dashcam-live-streaming .vs-slider {
  height: 6px;
}

.dashcam-live-streaming.includeIconOnly {
  width: 25px !important;
  height: 25px !important;
}

.dashcam-live-streaming .vs-slider--circles.isEndValue {
  border-radius: 50% !important;
}
</style>

<script>
import L from 'leaflet'
import {
  LMap,
  LTileLayer,
  LMarker,
  LTooltip,
  LControlLayers,
  LControl
} from 'vue2-leaflet'
import LRotatedMarker from 'vue2-leaflet-rotatedmarker'
import { Icon } from 'leaflet'

import 'leaflet/dist/leaflet.css'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowSize: [0, 0],
  iconSize: [20, 30]
})

export default {
  components: {
    LMap,
    LControl,
    LTileLayer,
    LMarker,
    LTooltip,
    LControlLayers,
    LRotatedMarker
  },

  data() {
    return {
      data: [],
      actor: {},
      token: '',
      showMap: true,
      mapHandle: true,

      tileProviders: [
        {
          name: 'Google Street',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Satellites',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Hybrid',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s,h@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Terrain',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=p@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Traffic',
          visible: true,
          url: 'https://www.google.com/maps/vt?lyrs=m@221097413,traffic&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        }
      ],
      map: {
        center: L.latLng(-6.21011, 106.832459), //-1.041276, 122.288486
        zoom: 12
      },
      mapOptions: {
        // zoomSnap: 0.5
      },

      selected: [],
      ws: '',
      isConnect: 'open',

      page: 1,
      per_page: 7,
      row_total: 0,
      keyword: '',
      timer: null,
      loading: true,

      notify: 'Server Error',

      onLive: false,
      interval: '',
      intervalDevice: '',
      counter: 0,
      selectCam: 0,

      camera: {
        limit_over: false,
        counter: 0,
        sound: false,
        current_time_video: 0,
        live_sec: 0,
        live_sec2: 0,
        limit: '00:00:00',
        limitSec: 0,
        timeStart: '',
        timeEnd: '',
        autoplay: false,
        imei: '',
        switch_video: 0,
        control: 'pause',
        video: false,
        type: 'flv',
        src: '',
        cmd: 'RTMP,ON,INOUT',
        media: {
          volume: 0,
          isLive: true,
          enableStashBuffer: false,
          autoCleanupSourceBuffer: false
        }
      },

      vehicle: {
        device_name: '',
        visible: false,
        imei: '',
        lon: 0,
        lat: 0,
        position: L.latLng(-6.21011, 106.832459),
        is_expired: false,
        server_time: '1970-01-01 00:00:00',
        alert: 0,
        acc: 0,
        speed: 0,
        angle: 0,
        time: '1970-01-01 00:00:00',
        address: '',
        icons: '',
        icon: {
          color: 'parking',
          value: 0,
          parking: '',
          label: '',
          acc_on: '',
          lost: '',
          alarm: ''
        }
      },

      current_live_sec: 0,
      fullscreen: false,
      is_disable_cam2: false,
      client_ip: '',
      count_send_off: 0,
      isMessageStopStream: true
    }
  },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 992
    },

    isWider() {
      return this.$store.state.windowWidth >= 1440
    },

    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    isWider() {
      this.initTable()
    },

    selectCam(data) {
      this.camera.switch_video = data
      if (!this.is_disable_cam2) this.switchVideo()
    },

    showMap(data) {
      if (data) {
        setTimeout(() => {
          this.mapHandle = data
        }, 500)
      } else this.mapHandle = data
    },

    onLive() {
      if (this.onLive) {
        this.interval = setInterval(() => {
          let getDate = this.convertDateTime(this.camera.timeEnd, 1)
          this.camera.timeEnd = getDate[0] + ' ' + getDate[1]

          let player = this.$refs['myPlayer'].$refs.flvPlayer
          if (player.currentTime == this.camera.current_time_video) {
            this.camera.counter = this.camera.counter + 1
            this.buffering()
          } else {
            let sec = this.camera.limitSec - 1

            this.$vs.loading.close(`#imgVideo > .con-vs-loading`)
            this.camera = {
              ...this.camera,
              counter: 0,
              live_sec: this.camera.live_sec + 1,
              // live_sec2: this.camera.live_sec2 + 1,
              limitSec: sec,
              limit: this.convertTime(sec)
            }
          }

          if (this.camera.limit_over) {
            this.limitOver()
            return
          }

          if (player.ended || this.camera.counter >= 60) {
            this.$refs['myPlayer'].destroy()
            this.camera.src = ''
            this.onLive = false
            this.saveLogStreaming(false)
            this.playStreaming(this.camera.imei, true, true, true)
            clearInterval(this.interval)
            clearInterval(this.intervalDevice)
          }

          if (this.camera.limitSec <= 0) {
            this.limitOver()
            return
          }

          if (this.camera.live_sec >= 120 && !player.ended) {
            // this.saveLogStreaming()
            this.set_current_live_sec()
          }

          // if (
          //   this.camera.live_sec2 - this.current_live_sec >= 120 &&
          //   !player.ended
          // ) {
          //   this.set_current_live_sec(this.camera.live_sec2)
          // }

          this.camera.current_time_video = player.currentTime
        }, 1000)

        this.intervalDevice = setInterval(() => {
          this.detail(this.vehicle.imei)
        }, 30000)
      }
    }
  },

  created() {
    if (localStorage.getItem('isGenerate') == 'true') {
      window.location.href = process.env.BASE_URL + 'error-404'
    }

    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })

    this.initTable(),
      window.addEventListener('beforeunload', () => {
        if (this.camera.live_sec > 0) {
          this.isMessageStopStream = false
          this.saveLogStreaming()
        }
      })
  },

  mounted() {
    this.client_ip = JSON.parse(localStorage.getItem('client_ip'))
  },

  beforeDestroy() {
    this.isMessageStopStream = false
    this.saveLogStreaming()
  },

  methods: {
    handleError(error) {
      console.log('Error code:', error.errorCode)
    },

    handleSound() {
      if (this.camera.video) {
        this.camera.sound = this.camera.sound ? false : true
      } else this.camera.sound = true
    },

    control() {
      if (this.camera.video) {
        if (this.camera.limit_over) {
          this.limitOver()
          return
        }

        if (this.camera.control == 'play') {
          this.camera.autoplay = false
          this.camera.control = 'pause'
          this.$refs['myPlayer'].pause()
          this.onLive = false
          this.isMessageStopStream = true
          // this.saveLogStreaming()
          this.stopStreaming(this.camera.imei)
          this.$vs.loading.close(`#imgVideo > .con-vs-loading`)
          clearInterval(this.interval)
          clearInterval(this.intervalDevice)
        } else {
          if (this.onLive) this.$refs['myPlayer'].destroy()

          this.camera.src = ''
          setTimeout(() => {
            this.playStreaming(this.camera.imei, true, true, true)

            this.onLive = true
            this.camera = {
              ...this.camera,
              control: 'play',
              autoplay: true
            }
          }, 250)
        }
      } else this.camera.control = 'pause'
    },

    switchVideo() {
      if (this.camera.video) {
        try {
          this.$refs['myPlayer'].destroy()
          this.camera.src =
            this.$api.connect_iothub +
            '/live/' +
            this.camera.switch_video +
            '/' +
            this.camera.imei +
            '.flv'
        } catch (error) {
          this.stopStreaming(this.camera.imei)
        }
      }
    },

    toggle() {
      this.fullscreen = !this.fullscreen
    },

    check(item, event) {
      this.vehicle.visible = false

      if (this.camera.video) {
        this.$refs['myPlayer'].pause()
        this.$refs['myPlayer'].destroy()
      }

      let visible = event.target.checked
      this.camera = {
        ...this.camera,
        video: false,
        src: '',
        imei: this.imei
      }

      if (visible) {
        this.detail(item.imei)

        this.camera = {
          ...this.camera,
          control: 'play',
          imei: item.imei,
          limit: '00:00:00',
          limit_over: false
        }

        this.playStreaming(item.imei, true, true, true)
      } else {
        this.camera.control = 'play'
        this.isMessageStopStream = false

        if (this.camera.live_sec > 0) this.stopStreaming(this.camera.imei)

        clearInterval(this.interval)

        // if (this.interval) {
        //   this.isMessageStopStream = false
        //   this.saveLogStreaming(true)
        //   this.stopStreaming(this.camera.imei)
        //   clearInterval(this.interval)
        // } else {
        //   this.isMessageStopStream = false
        //   this.stopStreaming(item.imei)
        // }

        this.camera = {
          ...this.camera,
          control: 'pause',
          imei: item.imei,
          limit: '00:00:00',
          limit_over: false
        }
      }

      this.selected = visible ? [] : [item.imei]

      // this.camera = {
      //   ...this.camera,
      //   // imei: visible ? item.imei : '',
      //   control: 'play',
      //   imei: item.imei,
      //   limit: '00:00:00',
      //   limit_over: false
      // }

      // this.camera.live_sec2 = 0
      this.current_live_sec = 0

      if (item.total_camera && item.total_camera > 1)
        this.is_disable_cam2 = false
      else {
        this.is_disable_cam2 = true
        this.selectCam = 0
      }
    },

    search() {
      this.loading = true
      this.data = []
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 500)
    },

    buffering() {
      this.$vs.loading({
        background: 'transparent',
        container: '#imgVideo',
        color: '#fff',
        scale: 1
      })
    },

    detail(imei) {
      this.$http
        .get(`${this.$api.endpoint}/gps/detail/${imei}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          const data = res.data.message.data
          let color = 'parking'

          if (data.is_expired) color = 'alarm'
          else {
            if (Date.now() - new Date(data.server_time).getTime() >= 86400000) {
              color = 'lost' // lost
            } else {
              if (data.alert != 0) color = 'alarm'
              //alarm
              else {
                if (
                  data.acc === 1 ||
                  (data.speed > 3 &&
                    Date.now() - new Date(data.time).getTime() <= 600000)
                ) {
                  color = 'acc_on' // acc_on
                } else color = 'parking' // parking
              }
            }
          }

          let list_icon = {
            color: color,
            value: data.fullpath_icon.id,
            parking: data.fullpath_icon.parking,
            label: data.fullpath_icon.name,
            acc_on: data.fullpath_icon.acc_on,
            lost: data.fullpath_icon.lost,
            alarm: data.fullpath_icon.alarm
          }

          let position = L.latLng(parseFloat(data.lat), parseFloat(data.lon))
          let marker_icon = L.icon({
            iconUrl: `${list_icon[color]}`,
            iconSize: [32, 32]
          })

          this.vehicle = {
            ...this.vehicle,
            device_name: data.device_name,
            visible: true,
            imei: imei,
            lon: data.lon,
            lat: data.lat,
            position: position,
            is_expired: data.is_expired,
            server_time: data.server_time,
            alert: data.alert,
            acc: data.acc,
            speed: data.speed,
            angle: data.angle,
            time: data.time,
            port: data.port,
            icons: marker_icon,
            icon: list_icon
          }

          this.map.center = position

          this.getAddress(data.lat, data.lon)
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    playStreaming(imei, autoplay, video, resetlimit) {
      this.camera.video = true
      let params = {
        imei: imei,
        command: this.camera.cmd,
        ip: localStorage.getItem('client_ip')
      }
      setTimeout(() => {
        this.buffering()
      }, 10)

      this.$http
        .post(`${this.$api.endpoint}/dashcam/connect`, params)
        .then((res) => {
          this.camera = {
            ...this.camera,
            src:
              this.$api.connect_iothub +
              '/live/' +
              this.camera.switch_video +
              '/' +
              this.camera.imei +
              '.flv',
            autoplay: autoplay,
            limit: this.convertTime(res.data.data.limit_live),
            limitSec: res.data.data.limit_live,
            video: true
          }

          if (this.camera.limitSec <= 0) {
            this.limitOver()
            return
          }

          this.onLive = resetlimit
          if (resetlimit) {
            let getDate = this.convertDateTime(new Date(), 0)
            let getDateTime = getDate[0] + ' ' + getDate[1]
            this.camera = {
              ...this.camera,
              timeStart: getDateTime,
              timeEnd: getDateTime
            }
          }
        })
        .catch((error) => {
          this.camera.video = video
          this.notify = 'Server Error'
          if (typeof error.response.data.message !== undefined) {
            this.notify = error.response.data.message.split('_').join(' ')
          }
          this.vehicle.visible = false
          this.$gf.httpErrorHandler(error)

          if (this.camera.video) {
            this.stopVideo(true)
            this.camera = {
              ...this.camera,
              video: false,
              control: 'pause',
              src: '',
              limit: '00:00:00',
              limit_over: false
            }
            this.interval = null
            this.$refs['myPlayer'].destroy()
          }
        })
        .finally(() => {
          this.$vs.loading.close(`#imgVideo > .con-vs-loading`)
        })
    },

    initTable() {
      if (!this.isWider) this.per_page = 5
      else this.per_page = 10

      let config = {
        headers: { Authorization: `Bearer ${this.token}` },
        params: {
          page: this.page,
          per_page: this.per_page,
          search: this.keyword
        }
      }
      this.$http
        .get(`${this.$api.endpoint}/gps/datatable_dashcam`, config)
        .then((res) => {
          this.row_total = res.data.data.total
          this.data = res.data.data.data_list
          this.loading = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    convertTime(totalSec) {
      const hour = Math.floor(totalSec / 3600)
      const minute = Math.floor((totalSec % 3600) / 60)
      const second = totalSec % 60
      const hours = hour < 10 ? '0' + hour : hour
      const minutes = minute < 10 ? '0' + minute : minute
      const seconds = second < 10 ? '0' + second : second

      const time = hours + ':' + minutes + ':' + seconds
      return time
    },

    convertDateTime(datetime, plusSec) {
      let time = new Date(datetime)
      time.setSeconds(time.getSeconds() + plusSec)
      let getMonth = parseInt(time.getMonth()) + 1
      let month = getMonth >= 10 ? getMonth : '0' + getMonth
      let date = time.getDate() >= 10 ? time.getDate() : '0' + time.getDate()
      let hour = time.getHours() >= 10 ? time.getHours() : '0' + time.getHours()
      let minute =
        time.getMinutes() >= 10 ? time.getMinutes() : '0' + time.getMinutes()
      let sec =
        time.getSeconds() >= 10 ? time.getSeconds() : '0' + time.getSeconds()
      let newDate = `${time.getFullYear()}-${month}-${date}`
      let newTime = `${hour}:${minute}:${sec}`
      return [newDate, newTime]
    },

    saveLogStreaming(isStopStreaming = true) {
      let params = {
        start_date: this.camera.timeStart,
        end_date: this.camera.timeEnd,
        second_live: this.camera.live_sec,
        imei: this.camera.imei,
        action: 1,
        camera: this.camera.switch_video,
        cmd_content: this.camera.cmd,
        isWeb: true,
        client_ip: this.client_ip
      }

      this.$http
        .post(`${this.$api.endpoint}/dashcam/store_log_streaming`, params)
        .then(() => {
          this.counter = 0
          this.camera.live_sec = 0

          // if (isStopStreaming) this.stopStreaming(this.camera.imei)
        })
        .catch(() => {
          if (this.counter <= 5) {
            setTimeout(() => {
              this.counter = this.counter + 1
              this.saveLogStreaming(isStopStreaming)
            }, 5000)
          }
        })
    },

    limitOver() {
      this.$vs.notify({
        title: 'Notification',
        text: 'Your limit is up, Please Top up',
        color: 'danger',
        position: 'top-right'
      })

      clearInterval(this.interval)
      this.camera.control = 'pause'
      this.onLive = false

      if (!this.camera.limit_over) {
        this.$refs['myPlayer'].pause()
        this.$refs['myPlayer'].destroy()
      }

      this.$vs.loading.close(`#imgVideo > .con-vs-loading`)
      this.isMessageStopStream = false
      // this.saveLogStreaming()
      this.stopStreaming(this.camera.imei)
      this.camera.limit_over = true
    },

    getAddress(lat, lon) {
      this.$http
        .get(`${this.$api.base_url}/api/address`, {
          params: {
            latitude: lat,
            longitude: lon
          }
        })
        .then((res) => {
          this.vehicle.address = res.data.message
          this.showAddress = true
        })
      // }
    },

    set_current_live_sec(value = 0) {
      // this.current_live_sec = value
      this.control()
      this.$vs.dialog({
        color: 'danger',
        title: `Pause`,
        text: 'Video paused, continue watching?',
        accept: this.acceptAlert
      })
    },

    acceptAlert() {
      this.control()
    },

    stopStreaming(imei) {
      let params = {
        imei: imei,
        command: 'RTMP,OFF,INOUT',
        ip: localStorage.getItem('client_ip')
      }

      this.$http
        .post(`${this.$api.endpoint}/dashcam/connect`, params)
        .then((res) => {
          if (this.isMessageStopStream) {
            this.$vs.notify({
              title: 'Paused',
              text: 'Video is currently paused',
              color: 'primary',
              position: 'top-right'
            })
          }

          this.saveLogStreaming(true)
        })
        .catch((error) => {
          this.stopStreaming(this.camera.imei)

          // if (this.count_send_off < 5) {
          //   setTimeout(() => {
          //     this.count_send_off = this.count_send_off + 1
          //     this.stopStreaming(imei)
          //   }, 5000)
          // }
          // this.notify = 'Server Error'
          // if (typeof error.response.data.message !== undefined) {
          //   this.notify = error.response.data.message.split('_').join(' ')
          // }
          // this.$gf.httpErrorHandler(error)
        })
    },

    stopVideo(storeLog) {
      clearInterval(this.interval)
      // if (storeLog) this.saveLogStreaming()
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/extraComponents/tree.scss';
</style>
